<template>
  <div class="fancy-price">
    <div class="price">
      <div class="dollars">${{dollars}}</div><div class="cents">{{cents}}</div>
      <div class="currency">USD</div>
    </div>
    <div v-if="hasDefaultSlot" class="price-text"><slot></slot></div>
  </div>
</template>

<style lang="sass" scoped>
.fancy-price
  text-align: center
  font-weight: 600

  .price
    font-size: 28pt
    white-space: nowrap
    text-align: center
    line-height: 1

    div
      display: inline-block
      margin: 0
      padding: 0

    .dollars
      text-align: right

    .cents
      font-size: 50%
      vertical-align: super
      text-align: left

    .currency
      font-size: 35%
      color: #ccc
      position: relative
      left: -28px
      width: 0

  .price-text
    display: block
    margin: 15px 0
    height: 1em
</style>

<script>
  export default {
    props: {
      price: Number,
      priceText: String
    },

    computed: {
      hasDefaultSlot () {
        return !!this.$slots.default
      },

      priceStr () {
        if (!this.price) return '0.00'
        return String(this.price.toFixed(2))
      },

      dollars () {
        return this.priceStr.split('.')[0]
      },

      cents () {
        return this.priceStr.split('.')[1]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// fancy-price.vue?8266b048